{
  "menu": {
    "dashboard": "Panel de control",
    "individuals": "Individuos",
    "nonIndividualClients": "Entidades no individuales",
    "households": "Hogares",
    "portfolioManagement": "Carteras",
    "clientManagement": "Clientes",
    "corporations": "Corporaciones",
    "modelPortfolios": "Carteras modelo",
    "modelPortfoliosV2": "Carteras modelo v2",
    "buildModels": "Construir modelos",
    "modelFamily": "Familia de modelos",
    "portfolioTemplates": "Plantillas",
    "productShelfPage": "Estante de productos",
    "assetClassesPage": "Clases de activos",
    "tradingSchedules": "Calendarios de negociación",
    "trading": "Negociación",
    "reports": "Informes",
    "rebalancing": "Reequilibrio",
    "bulkTrader": "Negociación en lote",
    "bulkImport": "Importación en lote",
    "compliance": "Cumplimiento",
    "complianceReview": "Revisión de cumplimiento",
    "transactionMonitoringTool": "Herramienta de monitoreo de transacciones",
    "elderlyClients": "Clientes mayores",
    "bankAccountsToReview": "Aprobación de nuevas cuentas bancarias",
    "institutionsToReview": "Aprobación de instituciones",
    "operations": "Operaciones",
    "reconciliation": "Reconciliación",
    "transactions": "Todas las transacciones",
    "accountsReview": "Revisión de cuentas",
    "settings": "Configuración",
    "orgSettings": "Organización",
    "newsAndInsights": "Noticias y perspectivas",
    "devSettings": "Integración",
    "bulkUpsertRequests": "Solicitudes de actualización en lote",
    "language": "Idioma",
    "logout": "Cerrar sesión",
    "addNewEntity": "Agregar nuevo perfil",
    "viewAllProfiles": "Ver todos los perfiles",
    "resourcesArticles": "Recursos y artículos",
    "contactSupport": "Contactar soporte",
    "actions": "Acciones",
    "statementsReview": "Revisión de estados de cuenta",
    "systemManagement": "Configuración",
    "rebalanceReport": "Informe de reequilibrio",
    "portfolioOptimizer": "Optimizador de cartera",
    "annualSuitabilityReview": "Actualización anual de información del perfil",
    "feeAndBilling": "Tarifas y facturación",
    "billingManagement": "Gestión de facturación",
    "feeGrids": "Cuadrículas de tarifas",
    "billingSchedules": "Calendarios de facturación",
    "incurredFees": "Gestión de facturación",
    "workflows": "Flujos de trabajo",
    "configureWorkflow": "Configurar flujo de trabajo",
    "pageConfiguration": "Configurar página",
    "staticPageWidgetConfiguration": "Configurar widget de página estática",
    "clientReportTemplate": "Plantilla de informe del cliente",
    "formTemplateEditor": "Editor de plantilla de formulario",
    "general": "General",
    "theme": "Tema",
    "designer": "Diseñador",
    "textDesigner": "Diseño de texto",
    "authenticationTheme": "Diseñador de autenticación",
    "errorTheme": "Página de error",
    "roles": "Roles",
    "roleSettings": "Configuración de roles",
    "users": "Usuarios",
    "authentication": "Autenticación",
    "accessSettings": "Configuración de acceso",
    "custodianAndAccounts": "Cuentas",
    "accounts": "Cuentas disponibles",
    "accountsList": "Cuentas",
    "accountGroupsList": "Grupos de cuentas",
    "custodianConnections": "Conexiones de custodia",
    "productExperience": "Experiencia del producto",
    "dashboards": "Paneles de control",
    "localization": "Localización",
    "notifications": "Notificaciones",
    "forms": "Formularios",
    "statementsAndTaxDocuments": "Estados de cuenta y documentos fiscales",
    "customFields": "Campos personalizados",
    "repCodes": "Códigos de representante",
    "pageConfigurations": "Configuraciones de página",
    "staticPageWidgetConfigurations": "Configuraciones de widgets de página estática",
    "downtimeSchedule": "Calendario de mantenimiento",
    "transfers": "Transferencias",
    "trades": "Operaciones",
    "assetClasses": "Clases de activos",
    "portfolioManagements": "Gestión de cartera",
    "portfolioManagementSettings": "Configuración de gestión de cartera",
    "feesAndBilling": "Tarifas y facturación",
    "embedded": "Integrado",
    "apiTokens": "Tokens de API",
    "webhooks": "Webhooks",
    "siemDataFeed": "Feed de datos SIEM",
    "integrations": "Integraciones",
    "accessUsers": "Usuarios de acceso",
    "clientReports": "Informes de clientes",
    "roleProfiles": "Perfiles de roles",
    "taxRankings": "Clasificaciones fiscales",
    "localizationConfiguration": "Configuración de localización",
    "generalProductExperience": "General",
    "formDefinitions": "Definiciones de formularios",
    "formMapper": "Mapeador de formularios",
    "featureFlags": "Indicadores de funcionalidad",
    "homePageConfiguration": "Configuración de la página de inicio",
    "homePageConfigurations": "Configuraciones de la página de inicio",
    "customAttributeLabels": "Etiquetas de atributos personalizados",
    "accountSettings": "Configuración de cuenta",
    "configurableTablePages": "Páginas de tablas configurables",
    "configurableTablePage": "Página de tabla configurable",
    "alertBanners": "Banners de Alerta",
    "bulkTraderRevamp": "Negociación en lote (Renovación)",
    "flags": "Indicadores",
    "flagPolicies": "Políticas de indicadores",
    "feeSettings": "General",
    "accountGroupSettings": "Configuración de Grupos de Cuentas",
    "rebalanceDashboard": "Panel de control de reequilibrio",
    "activities": "Actividades",
    "bulkRebalance": "Reequilibrio en lote",
    "admin": "Administrador",
    "advisorContact": "Contacto del asesor",
    "backToApp": "Volver a la aplicación"
  }
}
